import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { geoSliceSchema } from '../types/geoSchema';

const initialState: geoSliceSchema = {
  location: null,
  error: null,
  access: null,
  isLoaded: false,
};

export const geoSlice = createSlice({
  name: 'geoData',
  initialState,
  reducers: {
    initGeoData: (state, action: PayloadAction<geoSliceSchema>) => {
      state.location = action.payload.location;
      state.error = action.payload.error;
      state.access = action.payload.access;
      state.isLoaded = true;
    },
  },
});

export const { actions: actionsGeo } = geoSlice;
